import DropdownMenu from "components/dropdown-menu";

export const sizeOptions = ["12", "24", "48", "96"];

type PageSizeProps = {
  onChange: (newSize: number | undefined) => void;
  pageSize: number | undefined;
};
const PageSize = ({ onChange, pageSize }: PageSizeProps) => (
  <DropdownMenu
    options={sizeOptions}
    labelFormatter={v => `${v} per page`}
    onChange={newPage => onChange(Number(newPage))}
    selected={pageSize?.toString() || sizeOptions[0]}
    className="shrink-0"
  />
);

export default PageSize;
